import React from 'react';
import { Button, ButtonGroup, Form } from 'react-bootstrap';
import Octicon, { Search, X } from '@github/octicons-react';
import { SHOWS } from 'context/limitsFilter';

const limitsWord = (n) => (1 === n ? 'limit' : 'limits');

/** The Limits section's filter: a search field, the Show toggles with their counts, and the match count. */
export default function LimitsFilterBar({ query, show, counts, total, filtering, inputRef, onQuery, onShow }) {
  const onKeyDown = (event) => {
    if ('Escape' !== event.key) return;
    event.preventDefault();
    if (query) onQuery('');
    else event.currentTarget.blur();
  };
  const clear = () => {
    onQuery('');
    if (inputRef.current) inputRef.current.focus();
  };
  return (
    <div className="bh-filter-bar" role="search">
      <div className="bh-filter-search">
        <span className="bh-filter-search-icon d-flex"><Octicon icon={Search} /></span>
        <Form.Control type="search" size="sm" id="limits-filter" ref={inputRef} value={query}
          placeholder="Filter limits" aria-label="Filter limits by name, id, description or value"
          autoComplete="off" spellCheck={false} onChange={(event) => onQuery(event.target.value)}
          onKeyDown={onKeyDown} />
        {query
          ? (
            <Button variant="link" size="sm" className="bh-filter-search-end text-muted p-0 d-flex"
              aria-label="Clear filter" onClick={clear}>
              <Octicon icon={X} />
            </Button>
          )
          : <kbd className="bh-filter-search-end bh-filter-key" aria-hidden="true">/</kbd>}
      </div>
      <ButtonGroup size="sm" aria-label="Show">
        {SHOWS.map(({ key, label }) => (
          <Button key={key} variant="light" active={key === show} aria-pressed={key === show}
            disabled={0 === counts[key] && key !== show} onClick={() => onShow(key)}>
            {label}<span className="ml-1 text-muted">{counts[key]}</span>
          </Button>
        ))}
      </ButtonGroup>
      <span className="ml-auto small text-muted" aria-live="polite">
        {filtering ? `${counts[show]} of ${total} ${limitsWord(total)}` : `${total} ${limitsWord(total)}`}
      </span>
    </div>
  );
}
